import React from 'react';
import { Users, Clock, Award } from 'lucide-react';

export default function Hero() {
  return (
    <div className="relative bg-white">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="https://formation.michelcardinal.com/hero_image/hero.png"
          alt="Formation secourisme en milieu de travail"
        />
        <div className="absolute inset-0 bg-blue-900 opacity-75"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
          Scénarios de Formation en Secourisme
        </h1>
        <p className="mt-6 text-xl text-blue-100 max-w-3xl">
          Des mises en situation réalistes pour former efficacement vos apprenants aux gestes qui sauvent en milieu de travail.
        </p>
        
        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-3">
          <div className="flex items-center space-x-3 bg-white bg-opacity-10 p-4 rounded-lg">
            <Users className="h-8 w-8 text-blue-200" />
            <span className="text-white">Scénarios adaptables</span>
          </div>
          <div className="flex items-center space-x-3 bg-white bg-opacity-10 p-4 rounded-lg">
            <Clock className="h-8 w-8 text-blue-200" />
            <span className="text-white">Durées optimisées</span>
          </div>
          <div className="flex items-center space-x-3 bg-white bg-opacity-10 p-4 rounded-lg">
            <Award className="h-8 w-8 text-blue-200" />
            <span className="text-white">Différents niveaux</span>
          </div>
        </div>
      </div>
    </div>
  );
}